import React, { FC } from 'react'
import { Grid, Box } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingBottom: ({ paddingBottom }: StylePropTypes) => paddingBottom || theme.spacing(2),
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'baseline',
    width: ({ width }: StylePropTypes) => width,
  },
  keyStyle: {
    fontSize: '16px',
    color: 'white',
    opacity: '60%',
  },
}))

interface KeyValueProps {
  labelKeyValue: string
  delimiter?: string
  children: React.ReactNode
  minWidth?: number | string
  pb?: number | string
}

export type StylePropTypes = {
  width: number | string
  fontSize?: number | string
  paddingBottom?: number | string
  multiline?: boolean
}

export const KeyValue: FC<KeyValueProps> = (props: KeyValueProps) => {
  const { labelKeyValue, delimiter = ':', children, minWidth = '350px', pb } = props
  const stylePropTypes: StylePropTypes = {
    width: minWidth,
    paddingBottom: pb,
  }
  const classes = useStyles({ width: stylePropTypes.width, paddingBottom: stylePropTypes.paddingBottom })

  return (
    <Grid item className={classes.container} key={`${labelKeyValue}-${Math.random()}`}>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)' }}>
        <Grid item className={classes.keyStyle}>
          {labelKeyValue}
          {delimiter}
        </Grid>
        {children}
      </Box>
    </Grid>
  )
}
